//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export module irpsr {

/** Object that stores National Incomes Register Payer Summary Reports. */
export interface PayerSummary {
    /** Delivery data from IR Wage Report. */
    deliveryData?: DeliveryData | null;
    /** Salaxy data that can't be stored in Earnings Payment Report */
    info?: PayerSummaryReportExtensions | null;
    /** Validation for the Payer Summary Report */
    validation?: ApiValidation | null;
    /** Status of the Payer Summary Report. */
    status?: PayerSummaryReportStatus | null;
    /** IR Report log. Successfully sent or canceled report ids and time stamps. */
    reportLog?: ReportLogEntry[] | null;
    /** Last errors from IR. */
    irErrors?: ApiValidation | null;
    /** Last successful status in Incomes Register */
    irStatus?: ReportLogEventType | null;
    /** Current schedule for the report. */
    scheduledFor?: string | null;
    /** Timestamp of the last action in IR. */
    lastDeliveredAt?: string | null;
    /** If true, the report has been modified after the last send operation. */
    isModified?: boolean | null;
    /** Readonly workflow data, which is exposed to API. */
    workflowData?: WorkflowData | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Record data */
export interface DeliveryData {
    /** Time of record creation */
    timestamp?: string | null;
    /** Data source */
    source?: string | null;
    /** Record type */
    deliveryDataType?: DeliveryDataType | null;
    /** Record owner's (payer's) record reference */
    deliveryId?: string | null;
    /** Rule for processing invalid data (reports) */
    faultyControl?: FaultyControl | null;
    /** Production environment */
    productionEnvironment?: boolean | null;
    /** Record owner */
    deliveryDataOwner?: Id | null;
    /** Record creator */
    deliveryDataCreator?: Id | null;
    /** Record submitter */
    deliveryDataSender?: Id | null;
    /** Contact persons for the record */
    contactPersons?: ContactPerson[] | null;
    /** Report date */
    reportDate?: string | null;
    /** Payer details */
    payer?: Payer | null;
    /** Reports data */
    reports?: Report[] | null;
}

/** Salaxy data that can't be stored in payer summary report */
export interface PayerSummaryReportExtensions {
    /** Employer's Id */
    employerId?: string | null;
    /** All calculations on which the report is based. */
    calculationIds?: string[] | null;
}

/** Common base class / interface for data validation. */
export interface ApiValidation {
    /** If true, the data is valid - no errors. */
    readonly isValid?: boolean | null;
    /** If true, has required fields missing data. */
    readonly hasAllRequiredFields?: boolean | null;
    /** Validation errors on invalid field values. 
Note that required fields missing error messages are not here. Only the invalid values. */
    readonly errors?: ApiValidationError[] | null;
}

/** Log data from the successfull sending or cancellation. */
export interface ReportLogEntry {
    /** Response date from the Incomes Register. */
    irTimestamp?: string | null;
    /** Event type: Sending or cancellation. */
    eventType?: ReportLogEventType | null;
    /** Our own report id. */
    reportId?: string | null;
    /** Generated id from the Incomes Register. */
    irReportId?: string | null;
    /** Delivery id. */
    irDeliveryId?: string | null;
    /** Response id. */
    irResponseId?: string | null;
    /** Version. */
    irVersion?: number | null;
    /** User who sent the report. */
    user?: string | null;
    /** Credential of the user. */
    credential?: string | null;
    /** Storage version id. */
    versionId?: string | null;
    /** Message for the event. */
    message?: string | null;
}

/** Defines the data that IWorkflowItem must provide. */
export interface WorkflowData {
    /** Workflow events for the item. */
    events?: WorkflowEvent[] | null;
}

/** Employer Identifier */
export interface Id {
    /** Identifier type */
    type?: IdType | null;
    /** Identifier

If the "Identifier type" is "Business ID", the identifier must exist (according to information from the Business Information System (YTJ)).
If the "Identifier type" is "Finnish Personal Identification Number", the identifier must exist (according to information from the Population Information System (VTJ)). */
    code?: string | null;
    /** Country code

Mandatory data if "Identifier type" is other than "Business ID" or "Finnish Personal Identification Number". */
    countryCode?: string | null;
    /** Country name

Mandatory data if "Country code" is "99". */
    countryName?: string | null;
}

export interface ContactPerson {
    /** Name */
    name?: string | null;
    /** Telephone number */
    telephone?: string | null;
    /** E-mail address

If the ‘Reimbursement application data’ data group is specified for a paid absence and 1 or 2 as the ‘Payment data type’ even in a single report in a record, you must report at least one ‘Contact person for the record’ for whom the ‘E-mail address’ and ‘Field of responsibility’ data items have been specified. */
    email?: string | null;
    /** Field of responsibility

If the ‘Reimbursement application data’ data group is specified for a paid absence and 1 or 2 as the ‘Payment data type’ even in a single report in a record, you must report at least one ‘‘Contact person for the record’ for whom the ‘E-mail address’ and ‘Field of responsibility’ data items have been specified, with ‘Field of responsibility’ having the value 1 (Content issues). */
    responsibilityCode?: ResponsibilityCode | null;
}

/** Payer details */
export interface Payer {
    /** Payer identifiers */
    payerIds?: Id[] | null;
    /** Basic payer details */
    payerBasic?: PayerBasic | null;
    /** Payer's address */
    address?: Address | null;
    /** Payer's suborganisations */
    subOrgs?: SubOrg[] | null;
    /** Other payer details */
    payerOther?: PayerOther | null;
    /** Earnings-related pension insurances */
    pensionInsurances?: PensionInsurance[] | null;
    /** Occupational accident insurances */
    accidentInsurances?: AccidentInsurance[] | null;
}

/** Report data */
export interface Report {
    /** Service data */
    reportData?: ReportData | null;
    /** Reporting period */
    paymentMonth?: PaymentMonth | null;
    /** Income types */
    transactions?: Transaction[] | null;
}

/** Validation errors used in API output. */
export interface ApiValidationError {
    /** Full path to Name of the property / field (Member name in JSON).
This may be null/empty for type General. */
    key?: string | null;
    /** High level type: Specifies the relation to object and its Member. */
    type: ApiValidationErrorType;
    /** Validation error message in the requested language. */
    msg: string;
    /** Validation error long description in the requested language. */
    description?: string | null;
    /** Some error providers may have a unique technical code for error or validator */
    code?: string | null;
}

/** Event in the workflow */
export interface WorkflowEvent {
    /** Event-provider specific identifier for the event.
For deletable events, this should identify , but do NOT trust this to be 100% unique. */
    id?: string | null;
    /** Type of the event. This typically maps to parent-object specific enumeration. */
    type?: string | null;
    /** Message for backoffice purposes from the User or system that created the event. */
    message?: string | null;
    /** User Interface styling of the event: Indicates the severity for the end-user. */
    ui?: WorkflowEventUi | null;
    /** Features for this event. */
    features?: Features[] | null;
    /** UTC time for when the event occured. */
    time?: string | null;
    /** User or system that created the event. */
    user?: string | null;
    /** Credential of the user which is responsible of the event. */
    assignedTo?: string | null;
    /** Record attached to this event. */
    record?: string | null;
}

/** Basic payer details */
export interface PayerBasic {
    /** The payer does not have a customer ID

Mandatory data, if no identifiers have been specified in the "Payer identifiers" data group. */
    missingId?: boolean | null;
    /** Company name

Mandatory data in the following cases:
• No identifier where the "Identifier type" is "Business ID" or "Finnish Personal Identification Number" has been specified in the "Payer identifiers" data group, and "Last name" and "First name" have not been specified.
• The value of "The payer does not have a customer ID" is "true", and "Last name" and "First name" have not been specified. */
    companyName?: string | null;
    /** Last name

Mandatory data in the following cases:
• No identifier where the "Identifier type" is "Business ID" or "Finnish Personal Identification Number" has been specified in the "Payer identifiers" data group, and "Company name" has not been specified.
• The value of "The payer does not have a customer ID" is "true", and "Company name" has not been specified.
• The value of "Payer type" is "Temporary employer", and "Company name" has not been specified. */
    lastName?: string | null;
    /** First name

Mandatory data in the following cases:
• No identifier where the "Identifier type" is "Business ID" or "Finnish Personal Identification Number" has been specified in the "Payer identifiers" data group, and "Company name" has not been specified.
• The value of "The payer does not have a customer ID" is "true", and "Company name" has not been specified.
• The value of "Payer type" is "Temporary employer", and "Company name" has not been specified. */
    firstName?: string | null;
    /** Date of birth

Mandatory data in the following cases:
• No identifier where the "Identifier type" is "Finnish Personal Identification Number" has been specified in the "Payer identifiers" data group, and "Last name" and "First name" have been specified.
• The value of "The payer does not have a customer ID" is "true", and "Last name" and "First name" have been specified.
The date must not be later than the current date.
The date must not be earlier than 1 January 1800 */
    birthDate?: string | null;
    /** Contact language */
    language?: Language | null;
}

/** Address */
export interface Address {
    /** c/o */
    co?: string | null;
    /** Street address

If this data group is included, either "Street address" or "P.O. Box" must be specified.Both must not be entered. */
    street?: string | null;
    /** P.O. Box

If this data group is included, either "Street address" or "P.O. Box" must be specified.Both must not be entered. */
    poBox?: string | null;
    /** Postal code */
    postalCode?: string | null;
    /** City */
    postOffice?: string | null;
    /** Country code

A two-character code in accordance with the ISO 3166 country codes.
If the country is unknown, the value "99" is entered. */
    countryCode?: string | null;
    /** Country name

Mandatory data if "Country code" is "99" */
    countryName?: string | null;
}

/** Payer's suborganisations */
export interface SubOrg {
    /** Suborganisation’s identifier type */
    type?: PayerSubOrgType | null;
    /** Suborganisation identifier */
    code?: string | null;
}

/** Other payer details */
export interface PayerOther {
    /** Payer types */
    payerTypes?: PayerType[] | null;
}

/** Earnings-related pension insurances */
export interface PensionInsurance {
    /** Pension provider code */
    pensionProvIdCode?: PensionProvIdCode | null;
    /** Pension policy number */
    pensionPolicyNo?: string | null;
}

/** Occupational accident insurance If the "Action type" is "Replacement report", the data should match that of the report’s previous version. */
export interface AccidentInsurance {
    /** Occupational accident insurance company identifier */
    accInsProvId?: Id | null;
    /** Occupational accident insurance policy number */
    accInsPolicyNo?: string | null;
}

/** Service data */
export interface ReportData {
    /** Action type */
    actionCode?: ActionCode | null;
    /** Incomes Register report reference */
    irReportId?: string | null;
    /** Report reference */
    reportId?: string | null;
    /** Report version number */
    reportVersion?: number | null;
}

/** Reporting period */
export interface PaymentMonth {
    /** Payment month */
    month?: number | null;
    /** Payment year */
    year?: number | null;
}

/** Income type data */
export interface Transaction {
    /** General details on the income type */
    transactionBasic?: TransactionBasic | null;
}

/** General details on the income type */
export interface TransactionBasic {
    /** Income type code */
    summaryTransactionCode?: SummaryTransactionCode | null;
    /** Amount

Mandatory data, if the "Income type code" is not "101" (No wages payable) */
    amount?: number | null;
}

/** Api Schedule Object */
export interface IrApiScheduleObject {
    /** Id of the object in the data storage to schedule */
    id?: string | null;
    /** The date when the object was created. */
    startAt?: string | null;
    /** Schedule action to take. */
    action?: IrScheduleAction | null;
    /** User context information. */
    userContext?: UserContext | null;
}

/** Current user context. */
export interface UserContext {
    /** Owner for this data */
    owner?: string | null;
    /** Owner ID for this data */
    ownerId?: string | null;
    /** Partner ID for this data */
    partnerId?: string | null;
    /** Login partner ID for this data */
    loginPartnerId?: string | null;
    /** Credential ID for this data */
    credentialId?: string | null;
    /** Users scope, currently only 'admin' supported. */
    scope?: string | null;
}

/** Version information for the API object. */
export interface VersionInfo {
    /** Identifier for the version. */
    versionId?: string | null;
    /** Operation which created the version. */
    operation?: string | null;
    /** Date and time when the version was created. */
    date?: string | null;
    /** User account  who created the version. */
    userAccount?: Avatar | null;
}

/** Defines an avatar for an account, profile etc. - mainly the image that should be shown, names and short description */
export interface Avatar {
    /** Entity type: person/company */
    entityType?: AvatarEntityType | null;
    /** First name or company name */
    firstName?: string | null;
    /** Last name, for companies, this should be null */
    lastName?: string | null;
    /** Display name. For a person this is 'FirstName LastName' (auto-created). */
    displayName?: string | null;
    /** Sortable name for ordered lists etc. For a person this is 'LastName, FirstName' (auto-created).
Depending on the data storage, this may be all-lowercase for easier sorting and search. */
    sortableName?: string | null;
    /** Type of the Avatar picture. */
    pictureType?: AvatarPictureType | null;
    /** Color - currently only used by type Icon */
    color?: string | null;
    /** Initials - currently only used by type Icon */
    initials?: string | null;
    /** URL of the picture if specified as picture (null in a case of type Icon) */
    url?: string | null;
    /** Short description of the user. 
This may be overriden by a context specific value by the business logic. */
    description?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

export interface PageResultOfPayerSummaryListItem {
    items?: PayerSummaryListItem[] | null;
    nextPageLink?: string | null;
    count?: number | null;
}

/** Represents a single item in a list of payer summaries in the user interface. It contains all essential information of the report and is basis for searching, filtering and sorting. */
export interface PayerSummaryListItem {
    /** The date when the object was created. */
    createdAt?: string | null;
    /** The time when the object was last updated. 
Typically this should be a logical update by user (UserUpdatedAt in DTO), not technical updates. */
    updatedAt?: string | null;
    /** Person GUID for the owner of the object. */
    ownerId?: string | null;
    /** Metadata for the owner */
    ownerInfo?: AccountInIndex | null;
    /** The main status depending on the type of the object. */
    status?: PayerSummaryReportStatus | null;
    /** The back office status depending on the type of the object. */
    backOfficeStatus?: string | null;
    /** When the event started. Typically, this is the CreatedAt date, but it may be something else. */
    startAt?: string | null;
    /** This is the end date of the event.
Typically, it is the UserUpdatedAt date, but it may be something else - e.g PaidAt for the calculation. */
    endAt?: string | null;
    /** Gross salary if that is relevant to the transaction. */
    grossSalary?: number | null;
    /** This is the payment from the Owner point-of-view:
Total payment for the Employer and Net salary for the Worker in the case of a calculation.
Only add here the payment, if the payment is really made. */
    payment?: number | null;
    /** Estimated fee of the transaction to Palkkaus.fi. */
    fee?: number | null;
    /** The GUID for the other party. Currently, this is always the PersonID. */
    otherId?: string | null;
    /** The other party (usually a Person) that is involved in the event (e.g Worker if this is a Salary payment by Employer). */
    otherPartyInfo?: AccountInIndex | null;
    /** A very short description describing the object as an event. E.g. "Paid salary" */
    shortText?: string | null;
    /** Business object ids related to this object. E.g. calculations and payrolls in the payment. */
    businessObjects?: string[] | null;
    /** This is valid for calculations only. The estimated date of salary in worker. */
    salaryDate?: string | null;
    /** Business data to include further information of the object. */
    data?: PayerSummaryData | null;
    /** Version number. May be used in conflicts */
    versionNumber?: number | null;
    /** Salaxy uri of the resource. */
    uri?: string | null;
    /** Workflow flags for the object.
Only workflow events with API supported message types are listed. */
    flags?: string[] | null;
    /** Workflow messages for the object.
Only workflow events with API supported message types are listed.
Shown in format "[MessageType]:[Message] ([User] at [UTC-time])" */
    messages?: string[] | null;
    /** Sub category for the payload. E.g. Payment Category, MoneyTransfer Source. */
    entityType?: string | null;
    /** The date for the actual period for which this object is done. */
    logicalDate?: string | null;
    /** Reference information. E.g. Payment or MoneyTransfer reference number. */
    reference?: string | null;
    /** External id for the object in 3rd party system. */
    externalId?: string | null;
    /** Identifier of the object. */
    id?: string | null;
    /** Owner ID for this data */
    owner?: string | null;
    /** Indication that for the currently logged-in account, the data is generally read-only. */
    isReadOnly?: boolean | null;
    /** Primary partner information. Automatically updated from the storage container Partner. */
    partner?: string | null;
}

/** Object that represents a Salaxy account. */
export interface AccountInIndex {
    /** Avatar for the account */
    avatar?: Avatar | null;
    /** Official id of the person or company. */
    officialId?: string | null;
    /** Email address. */
    email?: string | null;
    /** Telephone number. */
    telephone?: string | null;
    /** Bank account number (IBAN) */
    ibanNumber?: string | null;
}

/** Payer summary specific business data for index. */
export interface PayerSummaryData {
    /** Contains the email or id of the responsible for the partner workflow event. */
    partnerMessageAssignedTo?: string | null;
    /** Current status in the Incomes Register. */
    irStatus?: ReportLogEventType | null;
    /** Date and time for the next scheduled delivery of the report. */
    scheduledFor?: string | null;
    /** Date and time for the first delivery of the report. */
    firstDeliveredAt?: string | null;
    /** Date and time for the last delivery of the report. */
    lastDeliveredAt?: string | null;
    /** Reported transaction code. */
    transactionCode?: number | null;
    /** Reported social security. */
    socialSecurity?: number | null;
    /** Reported social security deduction. */
    socialSecurityDeduction?: number | null;
}

export interface PayerSummaryNotification {
    /** Taken schedule action. */
    action?: ReportLogEventType | null;
    /** Status response for the sent request. */
    statusResponse?: StatusResponse | null;
    /** Record data */
    deliveryData?: DeliveryData | null;
    /** Identifier of the object in the data storage. */
    id?: string | null;
}

/** Processing feedback data */
export interface StatusResponse {
    /** Record status */
    deliveryDataStatus?: StatusResponseDeliveryDataStatus | null;
    /** Incomes Register record reference

If the record has been saved in the Incomes Register, the reference assigned to the record by the Incomes Register is delivered in this element.The Incomes Register record reference uniquely identifies all records submitted to the Incomes Register.
If the record has not been saved in the Incomes Register, this data is blank. */
    irDeliveryId?: string | null;
    /** Approved items

The valid items submitted in the record are returned in this data group. */
    validItems?: Item[] | null;
    /** Rejected items 

The invalid items submitted in the record and rejected on the basis of itemspecific errors are returned in this data group. If all items in the record are rejected on the basis of record-level errors, the rejected items are not returned in this data group. */
    invalidItems?: Item[] | null;
    /** Message-level errors

This data group is used to return technical and authorisation errors.
If message-level errors are detected in a record submitted to the Incomes Register, the record is not processed further in the Incomes Register. In addition to message-level errors, the processing feedback cannot therefore contain any other errors(record-level errors, and rejected items and the errors related to them). */
    messageErrors?: ErrorInfo[] | null;
    /** Record-level errors

This data group is used to return errors related to the contents of record-level data.
Record-level errors apply to all items in the record.If there are record-level errors in the record, all items of the record are invalid and will not be saved in the Incomes Register.In such a case, the invalid items are not separately delivered in the "Rejected items" data group. */
    deliveryErrors?: ErrorInfo[] | null;
    /** Incomes Register message reference */
    irResponseId?: string | null;
    /** Processing feedback timestamp */
    irResponseTimestamp?: string | null;
}

export interface Item {
    /** Record submitter's reference

This element always appears in the data of an approved item. */
    itemId?: string | null;
    /** Incomes Register reference 

This element always appears in the data of an approved item. */
    irItemId?: string | null;
    /** Report version number 

The Incomes Register assigns version number 1 to a new report. The version number of a substitute report is the number of the substituted version + 1. */
    itemVersion?: number | null;
    /** Item Version specified */
    itemVersionSpecified?: boolean | null;
    /** Errors */
    itemErrors?: ErrorInfo[] | null;
}

/** Error information */
export interface ErrorInfo {
    /** Error code */
    errorCode?: string | null;
    /** Error code description */
    errorMessage?: string | null;
    /** Error details */
    errorDetails?: string | null;
}

/** ActionCode enumeration */
export enum ActionCode {
    NewReport = "newReport",
    ReplacementReport = "replacementReport",
}

/** AddressType enumeration */
export enum AddressType {
    AddressInHomeCountry = "addressInHomeCountry",
    AddressInTheCountryOfWork = "addressInTheCountryOfWork",
}

/** AgeGroupCode enumeration */
export enum AgeGroupCode {
    A = "a",
    B = "b",
    C = "c",
    U = "u",
}

/** AllowanceCode enumeration */
export enum AllowanceCode {
    MealAllowance = "mealAllowance",
    PartialDailyAllowance = "partialDailyAllowance",
    FullDailyAllowance = "fullDailyAllowance",
    InternationalDailyAllowance = "internationalDailyAllowance",
    TaxExemptReimbursementsAbroad = "taxExemptReimbursementsAbroad",
}

/** ApiValidationErrorType enumeration */
export enum ApiValidationErrorType {
    General = "general",
    Required = "required",
    Invalid = "invalid",
    Warning = "warning",
}

/** BenefitCode enumeration */
export enum BenefitCode {
    AccommodationBenefit = "accommodationBenefit",
    TelephoneBenefit = "telephoneBenefit",
    MealBenefit = "mealBenefit",
    OtherBenefits = "otherBenefits",
}

/** CarBenefitCode enumeration */
export enum CarBenefitCode {
    LimitedCarBenefit = "limitedCarBenefit",
    FullCarBenefit = "fullCarBenefit",
}

/** DeliveryDataType enumeration */
export enum DeliveryDataType {
    EarningsPaymentReports = "earningsPaymentReports",
    EmployersSeparateReports = "employersSeparateReports",
    BenefitsPaymentReports = "benefitsPaymentReports",
    RecordSubscription = "recordSubscription",
    Messages = "messages",
    CancellationOfEarningsPaymentReports = "cancellationOfEarningsPaymentReports",
    CancellationOfEmployersSeparateReports = "cancellationOfEmployersSeparateReports",
    CancellationOfBenefitsPaymentReports = "cancellationOfBenefitsPaymentReports",
    CancellationOfARecordSubscription = "cancellationOfARecordSubscription",
    CancellationOfARecordContainingEarningsPaymentReports = "cancellationOfARecordContainingEarningsPaymentReports",
    CancellationOfARecordContainingEmployersSeparateReports = "cancellationOfARecordContainingEmployersSeparateReports",
    CancellationOfARecordContainingBenefitsPaymentReports = "cancellationOfARecordContainingBenefitsPaymentReports",
    CancellationOfARecordContainingARecordSubscription = "cancellationOfARecordContainingARecordSubscription",
}

/** EmploymentCode enumeration */
export enum EmploymentCode {
    FullTime = "fullTime",
    PartTime = "partTime",
    NotAvailable = "notAvailable",
}

/** EmploymentEndingCode enumeration */
export enum EmploymentEndingCode {
    EmployeesResignation = "employeesResignation",
    Other = "other",
    TerminationGroundsRelatedToEmployeesPerson = "terminationGroundsRelatedToEmployeesPerson",
    FinancialAndProductionRelatedGrounds = "financialAndProductionRelatedGrounds",
    JointAgreement = "jointAgreement",
    Retirement = "retirement",
    TerminationOfaFixedTermEmployment = "terminationOfaFixedTermEmployment",
}

/** EmploymentEndingType enumeration */
export enum EmploymentEndingType {
    KevaCodes = "kevaCodes",
    BankOfFinlandCodes = "bankOfFinlandCodes",
    IncomesRegisterCodes = "incomesRegisterCodes",
}

/** ExceptionCode enumeration */
export enum ExceptionCode {
    NoObligationToSocialInsurance = "noObligationToSocialInsurance",
    NoObligationToHealthInsurance = "noObligationToHealthInsurance",
    NoObligationToEarningsRelatedPensionInsurance = "noObligationToEarningsRelatedPensionInsurance",
    NoObligationToAccidentAndOccupationalDiseaseInsurance = "noObligationToAccidentAndOccupationalDiseaseInsurance",
    NoObligationToUnemploymentInsurance = "noObligationToUnemploymentInsurance",
    NotSubjectToSocialInsurance = "notSubjectToSocialInsurance",
    NotSubjectToEarningsRelatedPensionInsurance = "notSubjectToEarningsRelatedPensionInsurance",
    NotSubjectToAccidentAndOccupationalDiseaseInsurance = "notSubjectToAccidentAndOccupationalDiseaseInsurance",
    NotSubjectToUnemploymentInsurance = "notSubjectToUnemploymentInsurance",
    NotSubjectToHealthInsurance = "notSubjectToHealthInsurance",
    VoluntaryEarningsRelatedPensionInsurance = "voluntaryEarningsRelatedPensionInsurance",
}

/** FaultyControl enumeration */
export enum FaultyControl {
    OnlyInvalidItems = "onlyInvalidItems",
    EntireRecordIsRejected = "entireRecordIsRejected",
}

/** Gender enumeration */
export enum Gender {
    Male = "male",
    Female = "female",
}

/** IdType enumeration */
export enum IdType {
    BusinessId = "businessId",
    PersonalIdentificationNumber = "personalIdentificationNumber",
    Vat = "vat",
    Giin = "giin",
    TaxIdentificationNumber = "taxIdentificationNumber",
    FinnishTradeRegistrationNumber = "finnishTradeRegistrationNumber",
    ForeignBusinessRegistrationNumber = "foreignBusinessRegistrationNumber",
    ForeignPersonalIdentificationNumber = "foreignPersonalIdentificationNumber",
    Other = "other",
}

/** InsuranceCode enumeration */
export enum InsuranceCode {
    SubjectToSocialInsuranceContributions = "subjectToSocialInsuranceContributions",
    SubjectToEarningsRelatedPensionInsuranceContribution = "subjectToEarningsRelatedPensionInsuranceContribution",
    SubjectToHealthInsuranceContribution = "subjectToHealthInsuranceContribution",
    SubjectToUnemploymentInsuranceContribution = "subjectToUnemploymentInsuranceContribution",
    SubjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution = "subjectToAccidentInsuranceAndOccupationalDiseaseInsuranceContribution",
}

/** IrScheduleAction enumeration */
export enum IrScheduleAction {
    Send = "send",
    Cancel = "cancel",
}

/** Language enumeration */
export enum Language {
    Fi = "fi",
    Sv = "sv",
    En = "en",
}

/** PaidAbsenceCauseCode enumeration */
export enum PaidAbsenceCauseCode {
    Illness = "illness",
    PartTimeSickLeave = "partTimeSickLeave",
    ParentalLeave = "parentalLeave",
    SpecialMaternityLeave = "specialMaternityLeave",
    Rehabilitation = "rehabilitation",
    ChildIllness = "childIllness",
    PartTimeChildCareLeave = "partTimeChildCareLeave",
    Training = "training",
    LeaveOfAbsence = "leaveOfAbsence",
    MilitaryRefresherTraining = "militaryRefresherTraining",
    MidWeekHoliday = "midWeekHoliday",
    AccruedHoliday = "accruedHoliday",
    OccupationalAccident = "occupationalAccident",
    AnnualLeave = "annualLeave",
    PartTimeAbsenceDueToRehabilitation = "partTimeAbsenceDueToRehabilitation",
    Other = "other",
}

/** PayerType enumeration */
export enum PayerType {
    PublicSector = "publicSector",
    Household = "household",
    TemporaryEmployer = "temporaryEmployer",
    ForeignEmployer = "foreignEmployer",
    State = "state",
    UnincorporatedStateEnterpriseOrGovernmentalInstitution = "unincorporatedStateEnterpriseOrGovernmentalInstitution",
    SpecialisedAgency = "specialisedAgency",
    ForeignGroupCompany = "foreignGroupCompany",
    PoolOfHouseholdEmployers = "poolOfHouseholdEmployers",
}

/** PayerSubOrgType enumeration */
export enum PayerSubOrgType {
    KevasSubmitterCodes = "kevasSubmitterCodes",
    PayersOwnCodes = "payersOwnCodes",
    GovernmentAgencyIdentifier = "governmentAgencyIdentifier",
}

/** PayerSummaryReportStatus enumeration */
export enum PayerSummaryReportStatus {
    New = "new",
    Scheduled = "scheduled",
    Succeeded = "succeeded",
    Canceled = "canceled",
    Error = "error",
    Invalid = "invalid",
}

/** PaymentType enumeration */
export enum PaymentType {
    Monthly = "monthly",
    Hourly = "hourly",
    ContractPay = "contractPay",
}

/** PensionActCode enumeration */
export enum PensionActCode {
    EmployeesEarningsRelatedPensionInsurance = "employeesEarningsRelatedPensionInsurance",
    PensionInsuranceForFarmers = "pensionInsuranceForFarmers",
    PensionInsuranceForTheSelfEmployed = "pensionInsuranceForTheSelfEmployed",
}

/** PensionProvIdCode enumeration */
export enum PensionProvIdCode {
    None = "none",
    FinnishCentreForPensions = "finnishCentreForPensions",
    ClergyOfTheOrthodoxChurch = "clergyOfTheOrthodoxChurch",
    KevaMemberOrganisations = "kevaMemberOrganisations",
    KevaÅlandLandskapsregeringsPensionssystem = "kevaÅlandLandskapsregeringsPensionssystem",
    KevaChurch = "kevaChurch",
    BankOfFinland = "bankOfFinland",
    KevaKelaEmploymentPensions = "kevaKelaEmploymentPensions",
    KevaState = "kevaState",
    Seafarers = "seafarers",
    Farmers = "farmers",
    Alandia = "alandia",
    Ilmarinen = "ilmarinen",
    Elo = "elo",
    Varma = "varma",
    Veritas = "veritas",
    Etera = "etera",
    UPM = "uPM",
    Sanoma = "sanoma",
    Sandvik = "sandvik",
    Kontino = "kontino",
    Yleisradio = "yleisradio",
    ABB = "aBB",
    LFashionGroup = "lFashionGroup",
    Honeywell = "honeywell",
    Telia = "telia",
    YaraSuomi = "yaraSuomi",
    Orion = "orion",
    Valio = "valio",
    OP = "oP",
    Verso = "verso",
    Apteekkien = "apteekkien",
    Viabek = "viabek",
    Reka = "reka",
}

/** ProfessionType enumeration */
export enum ProfessionType {
    StatisticsFinland = "statisticsFinland",
    Keva = "keva",
    BankOfFinland = "bankOfFinland",
    Trafi = "trafi",
}

/** RefPaymentType enumeration */
export enum RefPaymentType {
    EarningsRelatedPensionProvider = "earningsRelatedPensionProvider",
}

/** ReimbPaymentType enumeration */
export enum ReimbPaymentType {
    KelaDailyAllowanceApplication = "kelaDailyAllowanceApplication",
    KelaFamilyLeaveCompensation = "kelaFamilyLeaveCompensation",
}

/** RemunerationCode enumeration */
export enum RemunerationCode {
    DailyAllowance = "dailyAllowance",
    AccommodationBenefit = "accommodationBenefit",
    CarBenefit = "carBenefit",
    OtherBenefit = "otherBenefit",
}

/** ReportLogEventType enumeration */
export enum ReportLogEventType {
    Undefined = "undefined",
    Sent = "sent",
    Canceled = "canceled",
    Error = "error",
}

/** ResponsibilityCode enumeration */
export enum ResponsibilityCode {
    ContentIssues = "contentIssues",
    TechnicalIssues = "technicalIssues",
}

/** SummaryTransactionCode enumeration */
export enum SummaryTransactionCode {
    Undefined = "undefined",
    NoWagesPayable = "noWagesPayable",
    EmployersHealthInsuranceContribution = "employersHealthInsuranceContribution",
    DeductionsToBeMadeFromTheEmployersHealthInsuranceContribution = "deductionsToBeMadeFromTheEmployersHealthInsuranceContribution",
}

/** TermCode enumeration */
export enum TermCode {
    UntilFurtherNotice = "untilFurtherNotice",
    FixedTerm = "fixedTerm",
}

/** TransactionCode enumeration */
export enum TransactionCode {
    Unknown = "unknown",
    Ignored = "ignored",
    TimeRatePay = "timeRatePay",
    InitiativeFee = "initiativeFee",
    BonusPay = "bonusPay",
    ComplementaryWagePaidDuringBenefitPeriod = "complementaryWagePaidDuringBenefitPeriod",
    EmergencyWorkCompensation = "emergencyWorkCompensation",
    EveningWorkCompensation = "eveningWorkCompensation",
    EveningShiftAllowance = "eveningShiftAllowance",
    NoticePeriodCompensation = "noticePeriodCompensation",
    KilometreAllowanceTaxable = "kilometreAllowanceTaxable",
    MeetingFee = "meetingFee",
    SaturdayPay = "saturdayPay",
    ExtraWorkPremium = "extraWorkPremium",
    HolidayBonus = "holidayBonus",
    LectureFee = "lectureFee",
    CompensationForTrustPosition = "compensationForTrustPosition",
    OtherCompensation = "otherCompensation",
    WaitingTimeCompensation = "waitingTimeCompensation",
    WorkingConditionCompensation = "workingConditionCompensation",
    PartialPayDuringSickLeave = "partialPayDuringSickLeave",
    Commission = "commission",
    SundayWorkCompensation = "sundayWorkCompensation",
    BenefitArisingFromSyntheticOption = "benefitArisingFromSyntheticOption",
    PerformanceBonus = "performanceBonus",
    MonetaryCompensationFromWorkingTimeBank = "monetaryCompensationFromWorkingTimeBank",
    CompensationForAccruedTimeOff = "compensationForAccruedTimeOff",
    ShareIssueForEmployees = "shareIssueForEmployees",
    ContractPay = "contractPay",
    DamagesInConjunctionWithTermination = "damagesInConjunctionWithTermination",
    StandByCompensation = "standByCompensation",
    VoluntaryCompensationInConjunctionWithTermination = "voluntaryCompensationInConjunctionWithTermination",
    WeeklyRestCompensation = "weeklyRestCompensation",
    ProfitSharingBonus = "profitSharingBonus",
    AnnualHolidayCompensation = "annualHolidayCompensation",
    OvertimeCompensation = "overtimeCompensation",
    NightWorkAllowance = "nightWorkAllowance",
    NightShiftCompensation = "nightShiftCompensation",
    OtherRegularCompensation = "otherRegularCompensation",
    CompensationForUnusedCompensatoryLeave = "compensationForUnusedCompensatoryLeave",
    AccommodationBenefit = "accommodationBenefit",
    InterestBenefitForHousingLoan = "interestBenefitForHousingLoan",
    MealAllowance = "mealAllowance",
    CarBenefit = "carBenefit",
    CompensationForGoverningBodyMembership = "compensationForGoverningBodyMembership",
    ShareOfReserveDrawnFromPersonnelFund = "shareOfReserveDrawnFromPersonnelFund",
    MonetaryGiftForEmployees = "monetaryGiftForEmployees",
    KilometreAllowanceTaxExempt = "kilometreAllowanceTaxExempt",
    TreatmentFeeForMunicipalVeterinarian = "treatmentFeeForMunicipalVeterinarian",
    CompensationForUseEarnedIncome = "compensationForUseEarnedIncome",
    CompensationForUseCapitalIncome = "compensationForUseCapitalIncome",
    OtherTaxableBenefitForEmployees = "otherTaxableBenefitForEmployees",
    OtherTaxableIncomeDeemedEarnedIncome = "otherTaxableIncomeDeemedEarnedIncome",
    OtherFringeBenefit = "otherFringeBenefit",
    KinshipCarersFee = "kinshipCarersFee",
    StockOptions = "stockOptions",
    WagesPaidBySubstitutePayerIncludingSocialInsurance = "wagesPaidBySubstitutePayerIncludingSocialInsurance",
    WagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance = "wagesPaidBySubstitutePayerIncludingEarningsRelatedPensionInsurance",
    WagesPaidBySubstitutePayerIncludingUnemploymentInsurance = "wagesPaidBySubstitutePayerIncludingUnemploymentInsurance",
    WagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance = "wagesPaidBySubstitutePayerIncludingAccidentAndOccupationalDiseaseInsurance",
    WagesPaidBySubstitutePayerIncludingHealthInsurance = "wagesPaidBySubstitutePayerIncludingHealthInsurance",
    CompensationForEmployeeInvention = "compensationForEmployeeInvention",
    ReimbursementOfPrivateCaretakersExpenses = "reimbursementOfPrivateCaretakersExpenses",
    PrivateCaretakersFee = "privateCaretakersFee",
    ReimbursementOfFamilyDayCareProvidersExpenses = "reimbursementOfFamilyDayCareProvidersExpenses",
    TelephoneBenefit = "telephoneBenefit",
    DailyAllowance = "dailyAllowance",
    CapitalIncomePayment = "capitalIncomePayment",
    MealBenefit = "mealBenefit",
    ReimbursementOfCostsPaidToConciliator = "reimbursementOfCostsPaidToConciliator",
    NonWageCompensationForWork = "nonWageCompensationForWork",
    SupplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund = "supplementaryDailyAllowancePaidByEmployerSpecificHealthInsuranceFund",
    PensionPaidByEmployer = "pensionPaidByEmployer",
    DividendsBasedOnWages = "dividendsBasedOnWages",
    DividendsBasedOnNonWage = "dividendsBasedOnNonWage",
    EmployerSubsidisedCommuterTicketTaxExempt = "employerSubsidisedCommuterTicketTaxExempt",
    EmployerSubsidisedCommuterTicketTaxable = "employerSubsidisedCommuterTicketTaxable",
    EmployeeStockOption = "employeeStockOption",
    WagesTransferredToAthletesSpecialFund = "wagesTransferredToAthletesSpecialFund",
    WagesPaidFromAthletesSpecialFund = "wagesPaidFromAthletesSpecialFund",
    WagesForInsurancePurposes = "wagesForInsurancePurposes",
    TaxableReimbursementOfExpenses = "taxableReimbursementOfExpenses",
    PrivateDayCareAllowanceMunicipalSupplement = "privateDayCareAllowanceMunicipalSupplement",
    PrivateDayCareAllowanceWages = "privateDayCareAllowanceWages",
    PrivateDayCareAllowanceNonWage = "privateDayCareAllowanceNonWage",
    KilometreAllowancePaidByNonProfitOrganisation = "kilometreAllowancePaidByNonProfitOrganisation",
    DailyAllowancePaidByNonProfitOrganisation = "dailyAllowancePaidByNonProfitOrganisation",
    UnjustEnrichment = "unjustEnrichment",
    EmployeeStockOptionLowerMarketPrice = "employeeStockOptionLowerMarketPrice",
    RoyaltyPaidToNonResidentTaxpayer = "royaltyPaidToNonResidentTaxpayer",
    BicycleBenefitTaxExempt = "bicycleBenefitTaxExempt",
    BicycleBenefitTaxable = "bicycleBenefitTaxable",
    ConditionalStockOptions = "conditionalStockOptions",
    CopyrightRoyaltiesEarnedIncome = "copyrightRoyaltiesEarnedIncome",
    StockGrantPaidInMoney = "stockGrantPaidInMoney",
    EmployeeStockOptionPaidInMoney = "employeeStockOptionPaidInMoney",
    EarningsFromJuELEmployerToLightEntrepreneur = "earningsFromJuELEmployerToLightEntrepreneur",
    CompensationCollectedForCarBenefit = "compensationCollectedForCarBenefit",
    WithholdingTax = "withholdingTax",
    ElectedOfficialFee = "electedOfficialFee",
    TaxAtSource = "taxAtSource",
    TaxAtSourceDeduction = "taxAtSourceDeduction",
    WagesPaid = "wagesPaid",
    ReimbursementCollectedForOtherFringeBenefits = "reimbursementCollectedForOtherFringeBenefits",
    OtherItemDeductibleFromNetWage = "otherItemDeductibleFromNetWage",
    NetWage = "netWage",
    EmployerPaidPremiumForCollectiveAdditionalPensionInsurance = "employerPaidPremiumForCollectiveAdditionalPensionInsurance",
    EmployerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution = "employerPaidPremiumForCollectiveAdditionalPensionInsuranceEmployeesContribution",
    EmployeesHealthInsuranceContribution = "employeesHealthInsuranceContribution",
    EmployeesPensionInsuranceContribution = "employeesPensionInsuranceContribution",
    EmployeesUnemploymentInsuranceContribution = "employeesUnemploymentInsuranceContribution",
    ReimbursementForEmployerSubsidisedCommuterTicket = "reimbursementForEmployerSubsidisedCommuterTicket",
    TaxPaidAbroad = "taxPaidAbroad",
    Distraint = "distraint",
    VoluntaryIndividualPensionInsurancePremium = "voluntaryIndividualPensionInsurancePremium",
    DeductionBeforeWithholding = "deductionBeforeWithholding",
    ReimbursementCollectedForBicycleBenefit = "reimbursementCollectedForBicycleBenefit",
}

/** UnpaidAbsenceCauseCode enumeration */
export enum UnpaidAbsenceCauseCode {
    Illness = "illness",
    PartTimeSickLeave = "partTimeSickLeave",
    ParentalLeave = "parentalLeave",
    SpecialMaternityLeave = "specialMaternityLeave",
    Rehabilitation = "rehabilitation",
    ChildIllness = "childIllness",
    PartTimeChildCareLeave = "partTimeChildCareLeave",
    Training = "training",
    JobAlternationLeave = "jobAlternationLeave",
    StudyLeave = "studyLeave",
    IndustrialAction = "industrialAction",
    InterruptionInWorkProvision = "interruptionInWorkProvision",
    LeaveOfAbsence = "leaveOfAbsence",
    MilitaryRefresherTraining = "militaryRefresherTraining",
    MilitaryService = "militaryService",
    LayOff = "layOff",
    ChildCareLeave = "childCareLeave",
    Other = "other",
}

/** WageUnitCode enumeration */
export enum WageUnitCode {
    Hour = "hour",
    Day = "day",
    Week = "week",
    Period = "period",
}

export enum WorkflowEventUi {
    Default = "default",
    Primary = "primary",
    Success = "success",
    Info = "info",
    Warning = "warning",
    Danger = "danger",
}

export enum Features {
    None = "none",
    IsActive = "isActive",
    IsEditable = "isEditable",
    IsRemovable = "isRemovable",
    IsOnHold = "isOnHold",
}

export enum AvatarEntityType {
    Undefined = "undefined",
    Person = "person",
    Company = "company",
    PersonCreatedByEmployer = "personCreatedByEmployer",
    Partner = "partner",
}

export enum AvatarPictureType {
    Icon = "icon",
    Uploaded = "uploaded",
    Gravatar = "gravatar",
}

export enum StatusResponseDeliveryDataStatus {
    Unknown = "unknown",
    Received = "received",
    InProcess = "inProcess",
    Valid = "valid",
    RejectedAtReception = "rejectedAtReception",
    RejectedDuringProcessing = "rejectedDuringProcessing",
    Cancelled = "cancelled",
}

}